import { render, staticRenderFns } from "./MediaListSkeleton.vue?vue&type=template&id=0865d048"
import script from "./MediaListSkeleton.vue?vue&type=script&lang=js"
export * from "./MediaListSkeleton.vue?vue&type=script&lang=js"
import style0 from "./MediaListSkeleton.vue?vue&type=style&index=0&id=0865d048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports